import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

import {APP_ROUTES} from '../../routes/routes'

const NotFound = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(APP_ROUTES.ROOT)
  }, [])

  return null
}

export default NotFound
